import React from 'react';
import { Input } from 'components/atoms/input';
import { EditSpaceTypes, KeyCodes } from './edit-space.types';

export const EditSpace = ({ space, onChange, onCancel }: EditSpaceTypes) => {
  const { spaceId, spaceName } = space;

  const update = (updatedSpaceName = '') => {
    if (updatedSpaceName.trim()) {
      onChange({
        ...space,
        spaceName: updatedSpaceName,
      });
      onCancel(space);
    }
  };

  const handleOnEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
    update(e.currentTarget.value);
  };

  const handleOnKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.keyCode === KeyCodes.Esc) {
      onCancel(space);
    }
  };

  const handleOnBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
    update(e.currentTarget.value);
  };

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <Input
      key={spaceId}
      autoFocus
      size="small"
      type="text"
      defaultValue={spaceName}
      onBlur={handleOnBlur}
      onPressEnter={handleOnEnter}
      onKeyDown={handleOnKeyDown}
      onClick={handleClick}
    />
  );
};
